import { useState, useEffect } from "react";
import './App.css';

// import NovoSizes1_6  from './images/Novo_Sizes_1-6.png';
// import NovoSizes7_9  from './images/Novo_Sizes_7-9.png';
// import NovoSizes10   from './images/Novo_Sizes_10-11.png';
// import NovoSizes12   from './images/Novo_Sizes_12-14.png';
// import NovoSizes18   from './images/Novo_Sizes_15-17.png';
// import NovoSizes20   from './images/Novo_Sizes_20+.png';
import TeroImage     from './images/Tero_Module.png';
import PhosClearImage from './images/PhosClear_Unit.png';

import { useCalcConfig, getBaseModel, getAddonQtys } from './useCalcConfig';

const BASE = 'https://tricel.co.uk/sewage-treatment/wp-content/plugins/wwtcalculator/build/static/media';

const novoImages = {
  '1-6':  `https://tricel.co.uk/sewage-treatment/wp-content/uploads/2026/06/Novo_Sizes_1-6.png`,
  '7-9':  `https://tricel.co.uk/sewage-treatment/wp-content/uploads/2026/06/Novo_Sizes_7-9.png`,
  '10-11': `https://tricel.co.uk/sewage-treatment/wp-content/uploads/2026/06/Novo_Sizes_10-11.png`,
  '12-14': `https://tricel.co.uk/sewage-treatment/wp-content/uploads/2026/06/Novo_Sizes_12-14.png`,
  '15-17': `https://tricel.co.uk/sewage-treatment/wp-content/uploads/2026/06/Novo_Sizes_15-17.png`,
  '20+':  `https://tricel.co.uk/sewage-treatment/wp-content/uploads/2026/06/Novo_Sizes_20.png`,
};

// ─────────────────────────────────────────────────────────────────────────────
// CONFIG — derived from wwt_calculator_uk_logic.xlsx
// PE = bedrooms + 2  (e.g. 1 bed → 3PE, 4 bed → 6PE)
// ─────────────────────────────────────────────────────────────────────────────

// Maps bedroom count → base model (no add-ons)
// function getBaseModel(bedrooms) {
//   if (bedrooms <= 4)  return "Tricel Novo UK6";
//   if (bedrooms <= 6)  return "Tricel Novo UK8";
//   if (bedrooms <= 8)  return "Tricel Novo UK10";
//   if (bedrooms <= 10) return "Tricel Novo UK12";
//   if (bedrooms <= 16) return "Tricel Novo UK18";
//   if (bedrooms <= 22) return "Tricel Novo UK24";
//   if (bedrooms <= 28) return "Tricel Novo UK30";
//   if (bedrooms <= 34) return "Tricel Novo UK36";
//   if (bedrooms <= 40) return "Tricel Novo UK42";
//   if (bedrooms <= 47) return "Tricel Novo UK50";
//   return "Tricel Combi Commercial Treatment Plant";
// }

// // Tero modules needed per base model (for E.coli / ammonia)
// const TERO_MODULES = {
//   "Tricel Novo UK6":  1, "Tricel Novo UK8":  2, "Tricel Novo UK10": 2,
//   "Tricel Novo UK12": 2, "Tricel Novo UK18": 3, "Tricel Novo UK24": 4,
//   "Tricel Novo UK30": 5, "Tricel Novo UK36": 6, "Tricel Novo UK42": 7,
//   "Tricel Novo UK50": 8,
// };

// // PhosClear units needed per base model (for phosphorous)
// const PhosClear_UNITS = {
//   "Tricel Novo UK6":  1, "Tricel Novo UK8":  1, "Tricel Novo UK10": 1,
//   "Tricel Novo UK12": 1, "Tricel Novo UK18": 2, "Tricel Novo UK24": 2,
//   "Tricel Novo UK30": 3, "Tricel Novo UK36": 3, "Tricel Novo UK42": 4,
//   "Tricel Novo UK50": 4,
// };

function getModelImage(baseModel, config) {
  const model = config?.base_models?.find(m => m.name === baseModel);
  return model?.image_url ?? null;
}

const TERO_IMAGE      = TeroImage;
const PhosClear_IMAGE = PhosClearImage;

// function App() {
//   const { config, loading } = useCalcConfig();

//   if (loading) return <div className="wwt-loading">Loading calculator…</div>;

//   // your existing JSX stays here, unchanged —
//   // just pass config into buildRecommendation when you call it


// }

function buildRecommendation(bedrooms, phosphorous, ecoli, ammonia, config) {
  const baseModel = getBaseModel(bedrooms, config);
 
  // COMMERCIAL threshold — no product to show, prompt contact
  if (baseModel === 'COMMERCIAL') {
    return { commercial: true };
  }
 
  const { teroQty, phosclearQty } = getAddonQtys(bedrooms, config);
 
  const needsTero      = ecoli === 'yes' || ammonia === 'yes';
  const needsPhosclear = phosphorous === 'yes';
 
  const addons = [];
  if (needsTero)      addons.push({ type: 'tero',      qty: teroQty });
  if (needsPhosclear) addons.push({ type: 'phosclear', qty: phosclearQty });
 
  // Combined: if both Tero AND PhosClear, Tero count wins for PhosClear too
  // (matches the Excel logic: "phosphorous + E.coli" row uses same teroQty)
  if (needsTero && needsPhosclear) {
    // Already correct — both are in addons with their respective qtys
  }
 
  return { baseModel, addons };
}

// PE for display
function calcPE(bedrooms, occupants) {
  const peB = bedrooms + 2;
  const peO = occupants || 0;
  return Math.min(Math.max(Math.max(peB, peO), 3), 50);
}

// ── Cost config ───────────────────────────────────────────────────────────────
const UNIT_PRICES = {
  "Tricel Novo UK6":  2500, "Tricel Novo UK8":  3000,
  "Tricel Novo UK10": 3400, "Tricel Novo UK12": 3800,
  "Tricel Novo UK18": 5500, "Tricel Novo UK24": 7200,
  "Tricel Novo UK30": 9000, "Tricel Novo UK36": 11000,
  "Tricel Novo UK42": 13000,"Tricel Novo UK50": 15000,
};

const INSTALLATION_BASE = {
  easy:     { low: 1500, high: 2300 },
  moderate: { low: 2000, high: 3000 },
  hard:     { low: 2700, high: 3800 },
};

const DISCHARGE_ADDONS = {
  drainage_field: { low: 2000, high: 6000 },
  watercourse:    { low: 250,  high: 750  },
  unsure:         { low: 0,    high: 0    },
};

const GROUND_MODIFIERS = {
  sand:    { low: 0,    high: 0    },
  gravel:  { low: 0,    high: 0.05 },
  loam:    { low: 0,    high: 0.05 },
  clay:    { low: 0.10, high: 0.20 },
  unknown: { low: 0,    high: 0.10 },
};

const roundTo50 = (n) => Math.round(n / 50) * 50;
const fmt = (n) => `£${n.toLocaleString("en-GB")}`;

function calcCosts(inputs, config) {
  const { bedrooms, occupants, access, discharge, ground, phosphorous, ecoli, ammonia } = inputs;
  const pe   = calcPE(bedrooms, occupants);
  const rec  = buildRecommendation(bedrooms, phosphorous, ecoli, ammonia, config);
  const unit = UNIT_PRICES[rec.baseModel] ?? null;

  let installedLow = null, installedHigh = null;

  if (unit && access && discharge && ground) {
    const inst = INSTALLATION_BASE[access];
    const disc = DISCHARGE_ADDONS[discharge];
    const gm   = GROUND_MODIFIERS[ground];
    const subL = inst.low  + disc.low;
    const subH = inst.high + disc.high;
    installedLow  = unit + roundTo50(subL * (1 + gm.low))  + (access === "hard" ? 250 : 0);
    installedHigh = unit + roundTo50(subH * (1 + gm.high)) + (access === "hard" ? 500 : 0);
  }

  const runLow  = 150 + 10 * Math.min(pe, 12) + 100;
  const runHigh = 250 + 20 * Math.min(pe, 12) + 200;
  const shortRange = pe >= 10 || (occupants && occupants > bedrooms + 2);

  return { pe, rec, installedLow, installedHigh, runLow, runHigh, shortRange };
}

// ── WordPress config ──────────────────────────────────────────────────────────
const WP = window.TricelConfig || {
  apiUrl: "http://localhost/wp-json/tricel/v1/",
  nonce:  "",
  siteUrl: window.location.origin,
};

function trackEvent(eventName, params = {}) {
  if (window.dataLayer) {
    window.dataLayer.push({ event: eventName, ...params });
  }
}

async function submitQuote(payload) {
  const res = await fetch(`${WP.apiUrl}submit-quote`, {
    method: "POST",
    headers: { "Content-Type": "application/json", "X-WP-Nonce": WP.nonce },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || `Server error ${res.status}`);
  }
  return res.json();
}

// ─────────────────────────────────────────────────────────────────────────────
// UI COMPONENTS
// ─────────────────────────────────────────────────────────────────────────────

function Stepper({ step, total = 3 }) {
  const labels = ["Property", "Treatment", "Results"];
  return (
    <div style={{ display:"flex", alignItems:"center", justifyContent:"center", gap:0, marginBottom:32 }}>
      {labels.slice(0, total).map((label, i) => {
        const idx = i + 1;
        const done = step > idx, active = step === idx;
        return (
          <div key={idx} style={{ display:"flex", alignItems:"center" }}>
            <div style={{ display:"flex", flexDirection:"column", alignItems:"center", gap:5 }}>
              <div style={{
                width:36, height:36, borderRadius:"50%",
                background: done ? "#1a6b3c" : active ? "#2d9e5f" : "transparent",
                border:`2px solid ${done||active ? "#2d9e5f" : "#c8d8cf"}`,
                display:"flex", alignItems:"center", justifyContent:"center",
                fontFamily:"Poppins", fontWeight:700, fontSize:14,
                color: done||active ? "#fff" : "#8aad99", transition:"all .3s",
              }}>{done ? "✓" : idx}</div>
              <span style={{ fontSize:10, letterSpacing:"0.07em", textTransform:"uppercase", color:active?"#1a3d2b":"#8aad99", fontFamily:"'DM Sans',sans-serif", fontWeight:active?600:400 }}>{label}</span>
            </div>
            {i < total - 1 && <div style={{ width:44, height:2, background:step>idx+1?"#2d9e5f":"#dde8e2", margin:"0 3px 18px" }} />}
          </div>
        );
      })}
    </div>
  );
}

function Tooltip({ text }) {
  const [open, setOpen] = useState(false);
  return (
    <span style={{ position:"relative", display:"inline-block", marginLeft:6 }}>
      <button onClick={()=>setOpen(!open)} style={{ background:"#e8f2ec", border:"none", borderRadius:"50%", width:18, height:18, fontSize:11, cursor:"pointer", color:"#2d9e5f", fontWeight:700, lineHeight:"18px", padding:0 }} aria-label="More info">?</button>
      {open && (
        <div style={{ position:"absolute", bottom:"calc(100% + 8px)", left:"50%", transform:"translateX(-50%)", background:"#1a3d2b", color:"#e8f2ec", padding:"10px 14px", borderRadius:8, fontSize:12, lineHeight:1.5, width:230, zIndex:20, fontFamily:"'DM Sans',sans-serif", boxShadow:"0 4px 20px rgba(0,0,0,.2)" }}>
          {text}
          <div style={{ textAlign:"right", marginTop:6 }}><button onClick={()=>setOpen(false)} style={{ background:"none", border:"none", color:"#7ec99a", fontSize:11, cursor:"pointer" }}>Close</button></div>
        </div>
      )}
    </span>
  );
}

function FieldLabel({ children, tooltip }) {
  return (
    <label style={{ display:"block", marginBottom:8, fontFamily:"'DM Sans',sans-serif", fontWeight:600, fontSize:13, letterSpacing:"0.05em", textTransform:"uppercase", color:"#2a4a36" }}>
      {children}{tooltip && <Tooltip text={tooltip} />}
    </label>
  );
}

function OptionGrid({ options, value, onChange, cols=2 }) {
  return (
    <div style={{ display:"grid", gridTemplateColumns:`repeat(${cols},1fr)`, gap:10 }}>
      {options.map(({ val, label, sub, icon }) => (
        <button key={val} onClick={()=>onChange(val)} style={{
          padding:"12px 10px", border:`2px solid ${value===val?"#2d9e5f":"#dde8e2"}`,
          borderRadius:10, background:value===val?"#edf7f1":"#fff",
          cursor:"pointer", textAlign:"center", fontFamily:"'DM Sans',sans-serif", transition:"all .2s",
          boxShadow:value===val?"0 0 0 3px rgba(45,158,95,.15)":"none",
        }}>
          {icon && <div style={{ fontSize:22, marginBottom:4 }}>{icon}</div>}
          <div style={{ fontWeight:600, fontSize:14, color:value===val?"#1a6b3c":"#2a4a36" }}>{label}</div>
          {sub && <div style={{ fontSize:11, color:"#7a9e8a", marginTop:3 }}>{sub}</div>}
        </button>
      ))}
    </div>
  );
}

function YesNo({ value, onChange }) {
  return (
    <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10 }}>
      {[{val:"yes",label:"Yes"},{val:"no",label:"No"}].map(({val,label})=>(
        <button key={val} onClick={()=>onChange(val)} style={{
          padding:"12px", border:`2px solid ${value===val?"#2d9e5f":"#dde8e2"}`,
          borderRadius:10, background:value===val?"#7AC143":"#fff",
          cursor:"pointer", fontFamily:"'DM Sans',sans-serif", fontWeight:600, fontSize:15,
          color:value===val?"#fff":"#2a4a36", transition:"all .2s",
          boxShadow:value===val?"0 0 0 3px rgba(45,158,95,.15)":"none",
        }}>{label}</button>
      ))}
    </div>
  );
}

function Slider({ min, max, value, onChange, label, marks, tooltip }) {
  return (
    <div>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"baseline", marginBottom:8 }}>
        <FieldLabel tooltip={tooltip}>{label}</FieldLabel>
        <span style={{ fontFamily:"Poppins", fontSize:22, fontWeight: "bold", color:"#2d9e5f" }}>{value===max?`${max}+`:value}</span>
      </div>
      <input type="range" min={min} max={max} value={value} onChange={(e)=>onChange(Number(e.target.value))} style={{ width:"100%", accentColor:"#2d9e5f", height:6 }} />
      {marks && <div style={{ display:"flex", justifyContent:"space-between", marginTop:4 }}>{marks.map((m)=><span key={m} style={{ fontSize:10, color:"#8aad99" }}>{m}</span>)}</div>}
    </div>
  );
}

function Btn({ children, onClick, variant="primary", disabled=false, style:extra={} }) {
  const base = { padding:"14px 28px", borderRadius:50, fontFamily:"'DM Sans',sans-serif", fontWeight:700, fontSize:15, cursor:disabled?"not-allowed":"pointer", border:"none", transition:"all .2s", letterSpacing:"0.02em", opacity:disabled?0.5:1 };
  const styles = {
    primary:   { background:"#295C3F", color:"#fff", boxShadow:"0 4px 16px rgba(45,158,95,.35)" },
    secondary: { background:"transparent", color:"#295C3F", border:"2px solid #2d9e5f" },
    ghost:     { background:"#f0f6f2", color:"#2a4a36" },
    cta:       { background:"#1a3d2b", color:"#fff", boxShadow:"0 4px 20px rgba(26,61,43,.35)" },
  };
  return <button onClick={disabled?undefined:onClick} style={{ ...base, ...styles[variant], ...extra }} className="button">{children}</button>;
}

function Banner({ children, color="#e8f2ec", border="#2d9e5f", icon, img}) {
  return (
    <div style={{ background:color, border:`1px solid ${border}`, borderRadius:10, padding:"12px 16px", marginBottom:12, display:"flex", gap:10, alignItems:"flex-start" }}>
      {icon ? <span style={{ fontSize:18, flexShrink:0 }}>{icon}</span> : <img src={img} alt="" />}
      <p style={{ margin:0, fontSize:13, color:"#2a4a36", lineHeight:1.6, fontFamily:"'DM Sans',sans-serif" }}>{children}</p>
    </div>
  );
}

function InfoTile({ label, value, icon, img }) {
  return (
    <div style={{ background:"#fff", borderRadius:12, padding:"14px 16px", border:"1px solid #dde8e2" }}>
      {/* <div style={{ fontSize:20, marginBottom:6, textAlign: "center" }}>{icon}</div> */}
      {img && <img src={img} style={{width: "50%", display: "block", margin: "0 auto", padding: "10px 0"}} />}
      <div style={{ fontSize:11, color:"#7a9e8a", textTransform:"uppercase", letterSpacing:"0.06em", fontFamily:"'DM Sans',sans-serif", marginBottom:4, textAlign: "center" }}>{label}</div>
      <div style={{ fontFamily:"Poppins", fontSize:15, fontWeight: "bold", color:"#7AC143", lineHeight:1.3, textAlign: "center" }}>{value}</div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// STEPS
// ─────────────────────────────────────────────────────────────────────────────

function Hero({ onStart }) {
  return (
    <div style={{ background:"#7AC143", borderRadius:20, padding:"48px 32px", textAlign:"center", marginBottom:32, position:"relative", overflow:"hidden" }}>
      {[180,300,430].map((size,i)=>(
        <div key={i} style={{ position:"absolute", width:size, height:size, borderRadius:"50%", border:"1px solid rgba(255,255,255,.06)", top:"50%", left:"50%", transform:"translate(-50%,-50%)", pointerEvents:"none" }} />
      ))}
      <div style={{ position:"relative" }}>
        <div style={{ display:"inline-block", background:"#295C3F", borderRadius:50, padding:"6px 16px", fontSize:12, color:"#fff", letterSpacing:"0.1em", textTransform:"uppercase", fontFamily:"'DM Sans',sans-serif", marginBottom:20 }}>
          Free • Instant • No obligation
        </div>
        <h3 style={{ fontFamily:"Poppins", color:"#fff", lineHeight:1.15, margin:"0 0 16px" }}>
          Which Sewage Treatment Solution do I need?
        </h3>
        <p style={{ color:"#fff", fontSize:15, margin:"0 0 28px", fontFamily:"'DM Sans',sans-serif", lineHeight:1.6, maxWidth:420, marginLeft:"auto", marginRight:"auto" }}>
          No surveys, no salespeople - just clear numbers.
        </p>
        <Btn onClick={onStart} style={{ fontSize:16, padding:"16px 36px", background:"#295C3F" }}>
          Start now →
        </Btn>
        <div style={{ display:"flex", justifyContent:"center", gap:24, marginTop:28, flexWrap:"wrap" }}>
          {["EC Certified","British Water Member","40+ Years Experience"].map((b)=>(
            <div key={b} style={{ display:"flex", alignItems:"center", gap:6, color:"#fff", fontSize:12, fontFamily:"'DM Sans',sans-serif" }}>
              <span style={{ color:"#fff" }}>✓</span> {b}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// Step 1 — Property basics + multi-property flag
function Step1({ data, onChange, onNext }) {
  const valid = data.bedrooms && data.multiProperty !== "";
  return (
    <div>
      <h2 style={sh2}>Tell us about your property</h2>
      <p style={sp}>We'll use this to find the right wastewater solution for your home.</p>

      <div style={sfield}>
        <FieldLabel>Are you managing several properties?</FieldLabel>
        <YesNo value={data.multiProperty} onChange={(v)=>onChange("multiProperty",v)} />
        {/* {data.multiProperty === "yes" && (
          <Banner icon="🏢" color="#f0f6f2" border="#2d9e5f">
            No problem — complete the selector for one property and we'll be in touch to discuss the full scope.
          </Banner>
        )} */}
      </div>

      <div style={sfield}>
        <Slider label="How many bedrooms do you have?" min={1} max={48} value={data.bedrooms} onChange={(v)=>onChange("bedrooms",v)}
          marks={["1","6","12","18","24","30","36","42","48+"]}
          tooltip="We use bedrooms to calculate Population Equivalent (PE) — the standard UK measure of sewage load." />
      </div>

      {/* <div style={sfield}>
        <Slider label="Occupants" min={1} max={50} value={data.occupants} onChange={(v)=>onChange("occupants",v)}
          marks={["1","10","20","30","40","50+"]} />
        <p style={{ ...sp, fontSize:12, marginTop:6 }}>If unsure, leave at 1 — we'll estimate from your bedroom count.</p>
      </div> */}

      <div style={{ marginTop:32 }}>
        <Btn onClick={onNext} style={{ width:"100%" }} disabled={!valid}>Next: Treatment requirements →</Btn>
      </div>
    </div>
  );
}

// Step 2 — Treatment requirements (phosphorous, E.coli, ammonia)
function Step2({ data, onChange, onNext, onBack }) {
  const valid = data.phosphorous !== "" && data.ecoli !== "" && data.ammonia !== "";
  return (
    <div>
      <h2 style={sh2}>Treatment requirements</h2>
      <p style={sp}>Some discharge locations require additional treatment. Answer below and we'll include the right add-ons in your recommendation.</p>
      <p style={{ ...sp, fontSize:12, background:"#f5faf7", padding:"10px 14px", borderRadius:8, borderLeft:"3px solid #2d9e5f" }}>
        Not sure? Your installer or the Environment Agency can advise based on your postcode. Select "No" for now.
      </p>

      <div style={sfield}>
        <FieldLabel tooltip="Required in some sensitive catchments to prevent algal blooms. Check your discharge consent for details.">
          Is phosphorous treatment required?
        </FieldLabel>
        <YesNo value={data.phosphorous} onChange={(v)=>onChange("phosphorous",v)} />
        {data.phosphorous === "yes" && (
          <Banner icon="💧" color="#e8f2ec" border="#2d9e5f">
            We'll include a <strong>PhosClear</strong> (gravity or pumped) unit in your recommendation.
          </Banner>
        )}
      </div>

      <div style={sfield}>
        <FieldLabel tooltip="Required if discharging to a bathing water or shellfish water designation. Rare for domestic installations.">
          Is E.coli treatment required?
        </FieldLabel>
        <YesNo value={data.ecoli} onChange={(v)=>onChange("ecoli",v)} />
        {data.ecoli === "yes" && (
          <Banner icon="🔬" color="#e8f2ec" border="#2d9e5f">
            We'll include <strong>Tero modules</strong> for E.coli reduction in your recommendation.
          </Banner>
        )}
      </div>

      <div style={sfield}>
        <FieldLabel tooltip="Some discharge consents require ammonia levels below 10mg/l. Check your consent conditions.">
          Is ammonia reduction required?
        </FieldLabel>
        <YesNo value={data.ammonia} onChange={(v)=>onChange("ammonia",v)} />
        {data.ammonia === "yes" && (
          <Banner img="/wwtcalculator/images/ammonia-3d.png" color="#e8f2ec" border="#2d9e5f">
            We'll include <strong>Tero modules</strong> for ammonia reduction in your recommendation.
          </Banner>
        )}
      </div>

      <div style={{ display:"flex", gap:12, marginTop:32 }}>
        <Btn variant="ghost" onClick={onBack} style={{ flex:1 }}>← Back</Btn>
        <Btn onClick={onNext} style={{ flex:2 }} disabled={!valid}>Next: See my solutions →</Btn>
      </div>
    </div>
  );
}

// Step 3 — Site & discharge
// function Step3({ data, onChange, onNext, onBack }) {
//   const valid = data.discharge && data.access && data.ground;
//   return (
//     <div>
//       <h2 style={sh2}>Site & discharge details</h2>
//       <p style={sp}>This helps us estimate installation complexity and any drainage work needed.</p>

//       <div style={sfield}>
//         <FieldLabel tooltip="Where treated water exits your system. A drainage field disperses it underground; a watercourse means a stream or ditch.">
//           Discharge type
//         </FieldLabel>
//         <OptionGrid cols={3} value={data.discharge} onChange={(v)=>onChange("discharge",v)} options={[
//           { val:"drainage_field", label:"Drainage field", sub:"Into ground",   icon:"🌱" },
//           { val:"watercourse",    label:"Watercourse",    sub:"Stream/ditch",  icon:"🌊" },
//           { val:"unsure",         label:"Not sure",       sub:"We'll advise",  icon:"❓" },
//         ]} />
//       </div>

//       <div style={sfield}>
//         <FieldLabel tooltip="How easily can a digger and delivery vehicle reach the installation area?">
//           Access difficulty
//         </FieldLabel>
//         <OptionGrid cols={3} value={data.access} onChange={(v)=>onChange("access",v)} options={[
//           { val:"easy",     label:"Easy",     sub:"Open driveway",    icon:"🟢" },
//           { val:"moderate", label:"Moderate", sub:"Some obstacles",   icon:"🟡" },
//           { val:"hard",     label:"Hard",     sub:"Narrow/restricted",icon:"🔴" },
//         ]} />
//       </div>

//       <div style={sfield}>
//         <FieldLabel>Ground type</FieldLabel>
//         <OptionGrid cols={3} value={data.ground} onChange={(v)=>onChange("ground",v)} options={[
//           { val:"sand",    label:"Sand"                },
//           { val:"gravel",  label:"Gravel"              },
//           { val:"loam",    label:"Loam"                },
//           { val:"clay",    label:"Clay",    sub:"Harder to dig" },
//           { val:"unknown", label:"Unknown", sub:"We'll confirm"  },
//         ]} />
//         <p style={{ ...sp, fontSize:12, marginTop:8 }}>If you're unsure, choose Unknown — we'll confirm during a site survey.</p>
//       </div>

//       <div style={{ display:"flex", gap:12, marginTop:32 }}>
//         <Btn variant="ghost" onClick={onBack} style={{ flex:1 }}>← Back</Btn>
//         <Btn onClick={onNext} style={{ flex:2 }} disabled={!valid}>See my estimate →</Btn>
//       </div>
//     </div>
//   );
// }

// Step 4 — Results
function Results({ inputs, config, onOptionA, onOptionB, onOptionC, onBack }) {
  const { pe, rec, installedLow, installedHigh, runLow, runHigh, shortRange } = calcCosts(inputs, config);
  const noPrice = rec.commercial || UNIT_PRICES[rec.baseModel] === undefined;
  const addonLabels = (rec.addons ?? []).map(a =>
    a.type === 'tero'
      ? `${a.qty} Tero module${a.qty > 1 ? 's' : ''}`
      : `${a.qty} PhosClear unit${a.qty > 1 ? 's' : ''}`
  );
  const fullModel = addonLabels.length ? `${rec.baseModel} + ${addonLabels.join(' + ')}` : rec.baseModel;
  const image = getModelImage(rec.baseModel, config);

  // Fire recommendation_viewed once when results are shown
  useEffect(() => {
    trackEvent('wwt_recommendation_viewed', {
      recommended_model: fullModel,
      bedrooms: inputs.bedrooms,
      pe,
      phosphorous: inputs.phosphorous,
      ecoli: inputs.ecoli,
      ammonia: inputs.ammonia,
    });
  }, []);

  return (
    <div>
      <h2 style={{ ...sh2, textAlign:"center" }}>Your Sewage Treatment Solution</h2>
      <p style={{ ...sp, textAlign:"center", marginBottom:20 }}>Based on your inputs.</p>

      {/* System Size tile */}
      <div style={{ display:"grid", gridTemplateColumns:"1fr", gap:12, marginBottom:16 }}>
        <InfoTile label="System size" value={`${pe} PE`} />
      </div>

      {/* Recommended Model tile */}
      <div style={{ background:"#fff", borderRadius:12, padding:"14px 16px", border:"1px solid #dde8e2", marginBottom:16 }}>
        <div style={{ fontSize:11, color:"#7a9e8a", textTransform:"uppercase", letterSpacing:"0.06em", fontFamily:"'DM Sans',sans-serif", marginBottom:10, textAlign:"center" }}>Recommended model</div>
        <div style={{ display:"flex", alignItems:"center", justifyContent:"center", gap:8 }} className="rec-model-cont">
          {/* Base model */}
          <div style={{ display:"flex", flexDirection:"column", width:90, alignItems:"center", gap:6 }}>
            {image && <img src={image} alt={rec.baseModel} style={{ width:90, height:"auto", display:"block" }} />}
            <span style={{ fontFamily:"Poppins", fontSize:13, fontWeight:700, color:"#7AC143", textAlign:"center" }}>{rec.baseModel}</span>
          </div>
          {/* Tero add-on */}
          {rec.addons.some(a => a.type === 'tero') && (
            <>
              <span style={{ fontFamily:"Poppins", fontSize:22, fontWeight:700, color:"#2d9e5f" }}>+</span>
              <div style={{ display:"flex", flexDirection:"column", width:90, alignItems:"center", gap:6 }}>
                <img src={TERO_IMAGE} alt="Tero module" style={{ width:90, height:"auto", display:"block" }} />
                <span style={{ fontFamily:"Poppins", fontSize:13, fontWeight:700, color:"#7AC143", textAlign:"center" }}>
                  {(() => { const a = rec.addons.find(a => a.type === 'tero'); return a ? `${a.qty} Tero module${a.qty > 1 ? 's' : ''}` : null; })()}
                </span>
              </div>
            </>
          )}
          {/* PhosClear add-on */}
          {rec.addons.some(a => a.type === 'phosclear') && (
            <>
              <span style={{ fontFamily:"Poppins", fontSize:22, fontWeight:700, color:"#2d9e5f" }}>+</span>
              <div style={{ display:"flex", flexDirection:"column", width:90, alignItems:"center", gap:6 }}>
                <img src={PhosClear_IMAGE} alt="PhosClear unit" style={{ width:"auto", height:100, display:"block" }} />
                <span style={{ fontFamily:"Poppins", fontSize:13, fontWeight:700, color:"#7AC143", textAlign:"center" }}>
                  {(() => { const a = rec.addons.find(a => a.type === 'phosclear'); return a ? `${a.qty} PhosClear unit${a.qty > 1 ? 's' : ''}` : null; })()}
                </span>
              </div>
            </>
          )}
        </div>
      </div>

      {/* Add-on callout */}
      {rec.addons.length > 0 && (
        <Banner icon="✅" color="#e8f2ec" border="#2d9e5f">
          Your recommendation includes advanced treatment add-ons: <strong>{addonLabels.join(" and ")}</strong>.
        </Banner>
      )}

      {/* Discharge banners */}
      {inputs.discharge === "watercourse" && (
        <Banner color="#fff7e6" border="#f5c842" icon="⚠️">
          Discharge to a stream or ditch may require consent. Your installer will guide you through the steps and confirm any additional items. Final pricing is subject to permit requirements.
        </Banner>
      )}
      {inputs.discharge === "unsure" && (
        <Banner icon="ℹ️">Discharge type affects final cost. We'll confirm the best option during your site survey.</Banner>
      )}

      <p style={{ fontSize:13, color:"#295C3F", textAlign:"center", lineHeight:1.6, margin:"16px 0 8px" }}>
        This recommendation is based on the details you’ve provided and is for guidance only. Our technical sales team can help confirm the right solution and provide an accurate price.
      </p>

      {/* "What would you like to do next?" */}
      <div style={{ background:"#f5faf7", borderRadius:14, padding:"20px", marginTop:16, border:"1px solid #dde8e2" }}>
        <h3 style={{ fontFamily:"Poppins", fontSize:18, color:"#1a3d2b", margin:"0 0 16px", textAlign:"center" }}>What would you like to do next?</h3>
        <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
          <Btn onClick={()=>onOptionA("Book a free site visit")} style={{ width:"100%", fontSize:15, padding:"15px 24px" }}>
            Book a free site visit
          </Btn>
          <Btn onClick={()=>onOptionB("Get a personalised quote")} style={{ width:"100%", fontSize:15, padding:"15px 24px" }}>
            Get a personalised quote
          </Btn>
          <Btn variant="secondary" onClick={()=>onOptionC("Email me my results & brochures")} style={{ width:"100%", fontSize:15 }}>
            Email me my results & brochures
          </Btn>
        </div>
      </div>

      <div style={{ textAlign:"center", marginTop:16 }}>
        <button onClick={onBack} style={{ background:"none", border:"none", color:"#7a9e8a", fontSize:13, cursor:"pointer", fontFamily:"'DM Sans',sans-serif" }}>← Adjust my inputs</button>
      </div>
    </div>
  );
}

// Lead form — Option A (quote/call/visit) — full details
function LeadFormA({ inputs, config, onSuccess, onBack, heading, leadType = "option_a" }) {
  const results = calcCosts(inputs, config);
  const { rec } = results;
  const addonLabels = (rec.addons ?? []).map(a =>
    a.type === 'tero'
      ? `${a.qty} Tero module${a.qty > 1 ? 's' : ''}`
      : `${a.qty} PhosClear unit${a.qty > 1 ? 's' : ''}`
  );
  const fullModel = addonLabels.length ? `${rec.baseModel} + ${addonLabels.join(' + ')}` : rec.baseModel;

  const [form,     setForm]     = useState({ firstName:"", lastName:"", email:"", phone:"", postcode:"", message:"" });
  const [errors,   setErrors]   = useState({});
  const [loading,  setLoading]  = useState(false);
  const [apiError, setApiError] = useState(null);
  const set = (k,v) => setForm(f=>({...f,[k]:v}));

  const validate = () => {
    const e = {};
    if (!form.firstName.trim()) e.firstName = "Please enter your first name.";
    if (!form.lastName.trim())  e.lastName  = "Please enter your last name.";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) e.email = "Please enter a valid email address.";
    if (!form.postcode.trim())  e.postcode  = "Please enter your postcode.";
    return e;
  };

  const handleSubmit = async () => {
    const e = validate();
    if (Object.keys(e).length) { setErrors(e); return; }
    setLoading(true); setApiError(null);
    const payload = {
      firstname: form.firstName, lastname: form.lastName,
      email: form.email,
      zip: form.postcode,
      phone: form.phone,
      message: form.message,
      lead_type: leadType,
      bedrooms: inputs.bedrooms,
      multiple_properties: inputs.multiProperty,
      phosphorous_treatment_required: inputs.phosphorous, ecoli_treatment_required: inputs.ecoli, ammonia_reduction_required: inputs.ammonia,
      pe: results.pe, recommended_model: fullModel,
      referrer_url: document.referrer || window.location.href,
    };
    try {
      const response = await submitQuote(payload);
      trackEvent('wwt_lead_form_submitted', {
        lead_type: heading,
        recommended_model: fullModel
      });
      onSuccess(response.reference, form.firstName);
    } catch (err) {
      setApiError(err.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2 style={sh2}>{heading}</h2>
      <p style={sp}>Share your details and we’ll connect you with a member of our Tricel technical sales team for clear, no obligation advice by phone, tailored to your project.</p>

      <div style={{ background:"#f5faf7", borderRadius:12, padding:"14px 16px", marginBottom:24, border:"1px solid #dde8e2" }}>
        <div style={{ fontSize:11, color:"#7a9e8a", textTransform:"uppercase", letterSpacing:"0.06em", marginBottom:4, fontFamily:"'DM Sans',sans-serif" }}>Your recommended system</div>
        <div style={{ fontFamily:"Poppins", fontSize:16, color:"#1a3d2b" }}>{fullModel}</div>
      </div>

      {[
        {key:"firstName", label:"First name"},
        {key:"lastName",  label:"Last name"},
        {key:"email",     label:"Email address"},
        {key:"postcode",  label:"Project postcode", hint:"Used to assign a regional installer"},
      ].map(({key,label,hint})=>(
        <div key={key} style={sfield}>
          <FieldLabel>{label} *</FieldLabel>
          <input value={form[key]} onChange={(e)=>set(key,e.target.value)}
            placeholder={hint || ""}
            style={{ width:"100%", padding:"12px 14px", border:`1.5px solid ${errors[key]?"#e05252":"#dde8e2"}`, borderRadius:10, fontSize:15, fontFamily:"'DM Sans',sans-serif", boxSizing:"border-box", outline:"none", color:"#1a3d2b" }}
          />
          {errors[key] && <p style={{ color:"#e05252", fontSize:12, marginTop:4 }}>{errors[key]}</p>}
        </div>
      ))}

      <div style={sfield}>
        <FieldLabel>Phone number (optional)</FieldLabel>
        <input value={form.phone} onChange={(e)=>set("phone",e.target.value)}
          style={{ width:"100%", padding:"12px 14px", border:"1.5px solid #dde8e2", borderRadius:10, fontSize:15, fontFamily:"'DM Sans',sans-serif", boxSizing:"border-box", color:"#1a3d2b" }}
        />
      </div>

      <div style={sfield}>
        <FieldLabel>Comments (optional)</FieldLabel>
        <textarea value={form.message} onChange={(e)=>set("message",e.target.value)} rows={3}
          placeholder="Any specific concerns, site details, or questions for your installer?"
          style={{ width:"100%", padding:"12px 14px", border:"1.5px solid #dde8e2", borderRadius:10, fontSize:14, fontFamily:"'DM Sans',sans-serif", boxSizing:"border-box", resize:"vertical", color:"#1a3d2b" }}
        />
      </div>

      {apiError && <Banner color="#fff0f0" border="#e05252" icon="⚠️">{apiError}</Banner>}

      <p style={{ fontSize:11, color:"#8aad99", marginBottom:20 }}>* Required. We'll never share your data with third parties.</p>

      <Btn onClick={handleSubmit} disabled={loading} style={{ width:"100%", fontSize:16, padding:"16px 28px" }}>
        {loading ? "Submitting…" : "Submit"}
      </Btn>
      <div style={{ textAlign:"center", marginTop:16 }}>
        <button onClick={onBack} style={{ background:"none", border:"none", color:"#7a9e8a", fontSize:13, cursor:"pointer", fontFamily:"'DM Sans',sans-serif" }}>← Back to results</button>
      </div>
    </div>
  );
}

// Lead form — Option B (brochures / email results)
function LeadFormB({ inputs, config, onSuccess, heading }) {
  const results = calcCosts(inputs, config);
  const { rec } = results;
  const addonLabels = (rec.addons ?? []).map(a =>
    a.type === 'tero'
      ? `${a.qty} Tero module${a.qty > 1 ? 's' : ''}`
      : `${a.qty} PhosClear unit${a.qty > 1 ? 's' : ''}`
  );
  const fullModel = addonLabels.length ? `${rec.baseModel} + ${addonLabels.join(' + ')}` : rec.baseModel;

  const [form,     setForm]     = useState({ firstName:"", lastName:"", email:"" });
  const [errors,   setErrors]   = useState({});
  const [loading,  setLoading]  = useState(false);
  const [apiError, setApiError] = useState(null);
  const set = (k,v) => setForm(f=>({...f,[k]:v}));

  const validate = () => {
    const e = {};
    if (!form.firstName.trim()) e.firstName = "Please enter your name.";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) e.email = "Please enter a valid email address.";
    return e;
  };

  const handleSubmit = async () => {
    const e = validate();
    if (Object.keys(e).length) { setErrors(e); return; }
    setLoading(true); setApiError(null);
    const payload = {
      firstname: form.firstName, lastname: form.lastName,
      email: form.email,
      lead_type: "option_b",
      property_type: inputs.propertyType, bedrooms: inputs.bedrooms,
      phosphorous: inputs.phosphorous, ecoli: inputs.ecoli, ammonia: inputs.ammonia,
      pe: results.pe, recommended_model: fullModel,
      referrer_url: document.referrer || window.location.href,
    };
    try {
      const response = await submitQuote(payload);
      onSuccess(response.reference, form.firstName, "b");
    } catch (err) {
      setApiError(err.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2 style={sh2}>{heading}</h2>
      <p style={sp}>Share your details and we’ll arrange a site visit with a member of our Tricel technical sales team to assess your needs and recommend the right solution.</p>

      <div style={sfield}>
        <FieldLabel>First name *</FieldLabel>
        <input value={form.firstName} onChange={(e)=>set("firstName",e.target.value)}
          style={{ width:"100%", padding:"12px 14px", border:`1.5px solid ${errors.firstName?"#e05252":"#dde8e2"}`, borderRadius:10, fontSize:15, fontFamily:"'DM Sans',sans-serif", boxSizing:"border-box", outline:"none", color:"#1a3d2b" }}
        />
        {errors.firstName && <p style={{ color:"#e05252", fontSize:12, marginTop:4 }}>{errors.firstName}</p>}
      </div>

      <div style={sfield}>
        <FieldLabel>Last name *</FieldLabel>
        <input value={form.lastName} onChange={(e)=>set("lastName",e.target.value)}
          style={{ width:"100%", padding:"12px 14px", border:`1.5px solid ${errors.lastName?"#e05252":"#dde8e2"}`, borderRadius:10, fontSize:15, fontFamily:"'DM Sans',sans-serif", boxSizing:"border-box", outline:"none", color:"#1a3d2b" }}
        />
        {errors.lastName && <p style={{ color:"#e05252", fontSize:12, marginTop:4 }}>{errors.lastName}</p>}
      </div>

      <div style={sfield}>
        <FieldLabel>Email address *</FieldLabel>
        <input value={form.email} onChange={(e)=>set("email",e.target.value)}
          style={{ width:"100%", padding:"12px 14px", border:`1.5px solid ${errors.email?"#e05252":"#dde8e2"}`, borderRadius:10, fontSize:15, fontFamily:"'DM Sans',sans-serif", boxSizing:"border-box", outline:"none", color:"#1a3d2b" }}
        />
        {errors.email && <p style={{ color:"#e05252", fontSize:12, marginTop:4 }}>{errors.email}</p>}
      </div>

      {apiError && <Banner color="#fff0f0" border="#e05252" icon="⚠️">{apiError}</Banner>}

      {/* <p style={{ fontSize:11, color:"#8aad99", marginBottom:20 }}>* Required. You'll also be added to a helpful 3-month follow-up sequence with installation guides and regulations.</p> */}

      <Btn onClick={handleSubmit} disabled={loading} style={{ width:"100%", fontSize:16, padding:"16px 28px" }}>
        {loading ? "Sending…" : "Book your site visit"}
      </Btn>
    </div>
  );
}
// Lead form — Option B (brochures / email results)
function LeadFormC({ inputs, config, onSuccess }) {
  const results = calcCosts(inputs, config);
  const { rec } = results;
  const addonLabels = (rec.addons ?? []).map(a =>
    a.type === 'tero'
      ? `${a.qty} Tero module${a.qty > 1 ? 's' : ''}`
      : `${a.qty} PhosClear unit${a.qty > 1 ? 's' : ''}`
  );
  const fullModel = addonLabels.length ? `${rec.baseModel} + ${addonLabels.join(' + ')}` : rec.baseModel;

  const [form,     setForm]     = useState({ firstName:"", lastName:"", email:"" });
  const [errors,   setErrors]   = useState({});
  const [loading,  setLoading]  = useState(false);
  const [apiError, setApiError] = useState(null);
  const set = (k,v) => setForm(f=>({...f,[k]:v}));

  const validate = () => {
    const e = {};
    if (!form.firstName.trim()) e.firstName = "Please enter your name.";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) e.email = "Please enter a valid email address.";
    return e;
  };

  const handleSubmit = async () => {
    const e = validate();
    if (Object.keys(e).length) { setErrors(e); return; }
    setLoading(true); setApiError(null);
    const payload = {
      firstname: form.firstName, lastname: form.lastName,
      email: form.email,
      lead_type: "option_c",
      bedrooms: inputs.bedrooms,
      multi_property: inputs.multiProperty,
      phosphorous: inputs.phosphorous, ecoli: inputs.ecoli, ammonia: inputs.ammonia,
      pe: results.pe, recommended_model: fullModel,
      referrer_url: document.referrer || window.location.href,
    };
    try {
      const response = await submitQuote(payload);
      onSuccess(response.reference, form.firstName, "b");
    } catch (err) {
      setApiError(err.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2 style={sh2}>Get a personalised quote</h2>
      <p style={sp}>Share your details and our Tricel technical sales team will provide a personalised, no obligation quote.</p>

      <div style={sfield}>
        <FieldLabel>First name *</FieldLabel>
        <input value={form.firstName} onChange={(e)=>set("firstName",e.target.value)}
          style={{ width:"100%", padding:"12px 14px", border:`1.5px solid ${errors.firstName?"#e05252":"#dde8e2"}`, borderRadius:10, fontSize:15, fontFamily:"'DM Sans',sans-serif", boxSizing:"border-box", outline:"none", color:"#1a3d2b" }}
        />
        {errors.firstName && <p style={{ color:"#e05252", fontSize:12, marginTop:4 }}>{errors.firstName}</p>}
      </div>

      <div style={sfield}>
        <FieldLabel>Last name *</FieldLabel>
        <input value={form.lastName} onChange={(e)=>set("lastName",e.target.value)}
          style={{ width:"100%", padding:"12px 14px", border:`1.5px solid ${errors.lastName?"#e05252":"#dde8e2"}`, borderRadius:10, fontSize:15, fontFamily:"'DM Sans',sans-serif", boxSizing:"border-box", outline:"none", color:"#1a3d2b" }}
        />
        {errors.lastName && <p style={{ color:"#e05252", fontSize:12, marginTop:4 }}>{errors.lastName}</p>}
      </div>

      <div style={sfield}>
        <FieldLabel>Email address *</FieldLabel>
        <input value={form.email} onChange={(e)=>set("email",e.target.value)}
          style={{ width:"100%", padding:"12px 14px", border:`1.5px solid ${errors.email?"#e05252":"#dde8e2"}`, borderRadius:10, fontSize:15, fontFamily:"'DM Sans',sans-serif", boxSizing:"border-box", outline:"none", color:"#1a3d2b" }}
        />
        {errors.email && <p style={{ color:"#e05252", fontSize:12, marginTop:4 }}>{errors.email}</p>}
      </div>

      {apiError && <Banner color="#fff0f0" border="#e05252" icon="⚠️">{apiError}</Banner>}

      {/* <p style={{ fontSize:11, color:"#8aad99", marginBottom:20 }}>* Required. You'll also be added to a helpful 3-month follow-up sequence with installation guides and regulations.</p> */}

      <Btn onClick={handleSubmit} disabled={loading} style={{ width:"100%", fontSize:16, padding:"16px 28px" }}>
        {loading ? "Sending…" : "Get your personalised quote"}
      </Btn>
    </div>
  );
}

function ThankYou({ reference, name, type, buttonLabel }) {

  const messages = {
    "Book a free site visit":           `Thank you for using the Tricel wastewater treatment calculator. One of our technical sales experts will contact you shortly to guide you through the next steps and arrange your free site visit. 
                                          You’ll also receive your personalised recommendation by email—be sure to check it out.`,
    "Get a personalised quote":         `Thank you for using the Tricel wastewater treatment calculator. One of our technical sales experts will contact you shortly to guide you through the next steps and arrange your personalised quote. 
                                          You’ll also receive your recommendation by email—be sure to check it out.`,
    "Email me my results & brochures":  "Thank you for using the Tricel wastewater treatment calculator. Your results, along with links to the relevant brochures, are on their way—be sure to check your inbox.",
  };

  const message = messages[buttonLabel] || "We'll be in touch shortly.";


  return (
    <div style={{ textAlign:"center", padding:"16px 0" }}>
      <h2 style={{ fontFamily:"Poppins", fontSize:28, color:"#1a3d2b", marginBottom:12 }}>
        Thanks, {name || "there"}!
      </h2>
        <p style={{ ...sp, maxWidth:340, margin:"0 auto 24px" }}>
          {message}
        </p>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// SHARED STYLES
// ─────────────────────────────────────────────────────────────────────────────
const sh2    = { fontFamily:"Poppins", fontSize:26, color:"#1a3d2b", margin:"0 0 8px", lineHeight:1.2 };
const sp     = { fontFamily:"'DM Sans',sans-serif", color:"#5a8070", fontSize:14, margin:"0 0 8px", lineHeight:1.6 };
const sfield = { marginBottom:24 };

// ─────────────────────────────────────────────────────────────────────────────
// MAIN APP
// ─────────────────────────────────────────────────────────────────────────────
export default function TricelCalculator() {
  const [screen,   setScreen]   = useState("hero");
  const [thankYou, setThankYou] = useState({ reference:"", name:"", type:"a", buttonLabel: "" });
  const [formHeading, setFormHeading] = useState("");
  const [inputs,   setInputs]   = useState({
    multiProperty:"", propertyType:"", bedrooms:3, occupants:1,
    phosphorous:"", ecoli:"", ammonia:"",
    discharge:"", access:"", ground:"",
  });
  const { config, loading } = useCalcConfig();
  const [formConfig, setFormConfig] = useState({ leadType: "option_a", heading: "" });

  const update = (k,v) => setInputs(p=>({...p,[k]:v}));

  const stepNum = { hero:0, step1:1, step2:2, results:3, form:4 }[screen] || 0;

  if (loading) return (
    <div style={{ display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"'DM Sans',sans-serif", color:"#5a8070" }}>
      Loading calculator…
    </div>
  );

  return (
    <div className="tricel-wwt">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:wght@400;500;600;700&display=swap');
        * { box-sizing:border-box; }
        .tricel-wwt input[type=range] { -webkit-appearance:none; appearance:none; background:#dde8e2; height:6px; border-radius:3px; outline:none; width:100%; }
        .tricel-wwt input[type=range]::-webkit-slider-thumb { -webkit-appearance:none; width:22px; height:22px; background:#2d9e5f; border-radius:50%; cursor:pointer; box-shadow:0 2px 8px rgba(45,158,95,.4); }
        .tricel-wwt button:hover { opacity:.88; transform:translateY(-1px); }
        .tricel-wwt button:active { transform:translateY(0); opacity:1; }
        .tricel-wwt input:focus, textarea:focus { border-color:#2d9e5f !important; box-shadow:0 0 0 3px rgba(45,158,95,.15); }
      `}</style>

      <div style={{ display:"flex", alignItems:"flex-start", justifyContent:"center", padding:"32px 16px", fontFamily:"'DM Sans',sans-serif" }}>
        <div style={{ width:"100%", maxWidth:560 }}>

          {screen === "hero" && <Hero onStart={()=>{ setScreen("step1"); trackEvent('wwt_calculator_started');}} />}

          {["step1","step2","results","form"].includes(screen) && (
            <div style={{ background:"#fff", borderRadius:20, padding:"32px 28px", boxShadow:"0 4px 32px rgba(26,61,43,.08)" }}>
              <Stepper step={stepNum} />

              {screen === "step1" && (
                <Step1 data={inputs} onChange={update}
                  onNext={()=>{ if( inputs.multiProperty !== "") { trackEvent('wwt_calculator_step_completed', {
                    step: 1, step_name: 'property', multiple_properties: inputs.multiProperty, bedrooms: inputs.bedrooms }); setScreen("step2"); }}} />
              )}
              {screen === "step2" && (
                <Step2 data={inputs} onChange={update}
                  onNext={()=>{ if(inputs.phosphorous && inputs.ecoli && inputs.ammonia) { trackEvent('wwt_calculator_step_completed',
                    { step: 2, step_name: 'treatment', phosphorous: inputs.phosphorous, ecoli: inputs.ecoli, ammonia: inputs.ammonia }); setScreen("results"); }}}
                  onBack={()=>setScreen("step1")} />
              )}
              {/* {screen === "step3" && (
                <Step3 data={inputs} onChange={update}
                  onNext={()=>{ if(inputs.discharge && inputs.access && inputs.ground) setScreen("results"); }}
                  onBack={()=>setScreen("step2")} />
              )} */}
              {screen === "results" && (
                <Results inputs={inputs} config={config}
                  onOptionA={() => { setFormConfig({ leadType: "option_a", heading: "Book a free site visit" }); setScreen("form"); }}
                  onOptionB={() => { setFormConfig({ leadType: "option_b", heading: "Get a personalised quote" }); setScreen("form"); }}
                  onOptionC={() => { setFormConfig({ leadType: "option_c", heading: "Email me my results & brochures" }); setScreen("form"); }}
                  onBack={()=>setScreen("step2")} />
              )}
              {screen === "form" && (
                <LeadFormA inputs={inputs} config={config}
                  heading={formConfig.heading}
                  leadType={formConfig.leadType}
                  onSuccess={(ref, name) => { setThankYou({ reference: ref, name, buttonLabel: formConfig.heading }); setScreen("thanks"); }}
                  onBack={() => setScreen("results")} />
              )}
            </div>
          )}

          {screen === "thanks" && (
            <div style={{ background:"#fff", borderRadius:20, padding:"32px 28px", boxShadow:"0 4px 32px rgba(26,61,43,.08)" }}>
              <ThankYou reference={thankYou.reference} name={thankYou.name} type={thankYou.type} buttonLabel={thankYou.buttonLabel} />
            </div>
          )}

        </div>
      </div>
    </div>
  );
}